import { getSdk, Sdk } from "../../graphql/shopify/client/sdk";

import BaseShopifyService, { Config } from "./BaseShopifyService";

export default class ClientShopifyService extends BaseShopifyService<Sdk> {
  constructor(config: Omit<Config, "getSdk">) {
    super({ ...config, getSdk });
  }
}
